import React, { forwardRef, useEffect, useState } from "react";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
} from "../StyledComp/StyledComp";
import { useDispatch } from "react-redux";
import {
  updateMember_Sections,
  updateMember_Tags,
} from "../../store/memberApiSlice";
import { useAppSelector } from "../../store/hooks";
import { resetOrderParameters } from "../../store/orderApiSlice";
import {
  // Outlet,
  useNavigate,
} from "react-router-dom";
import OrderServices from "../../services/OrderServices";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
  Status: boolean;
}

interface IFunctionOrders {
  MemberId: number | null;
  OrderId: number | null;
  EventId: number | null;
  LocationId: number | null;
  CostId: number | null;
}

interface ISeminarOrders {
  MemberId: number | null;
  OrderId: number | null;
  EventId: number | null;
  LocationId: number | null;
  CostId: number | null;
}

interface IMemberShipOrders {
  Id: number | null;
  OrderId: number | null;
  MemberId: number | null;
  MemberCodeId: number | null;
  LastYearSections: string | null;
  CurrentYearSections: string | null;
  CurrentYearSectionsNotPaid: string | null;
  Description: string | null;
  Fee: number | null;
  MemberCode: string | null;
}

interface IActiveOrder {
  FunctioOrders: IFunctionOrders[];
  SeminarOrders: ISeminarOrders[];
  memberShipOrderDetails: IMemberShipOrders[];
}

const initalActiveOrder: IActiveOrder = {
  FunctioOrders: [],
  SeminarOrders: [],
  memberShipOrderDetails: [],
};

interface IProps {
  section: ISection;
  isAdvanceOrder : boolean;
  isAddSectionFlow: boolean;
  // isSection: boolean;
  // membersActiveOrders?: IMemberShipOrders[];
  onChangeFunction: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: ISection
  ) => void;
}

const MDEditSectionMultipleOptionItems: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const section = props.section;
  console.log(props.section.SectionName, ",", props.section.isSelected);
  const currentMember = useAppSelector((state) => state.currentMember);
  const [checkboxIsSelected, setCheckboxIsSelected] = useState<boolean>(
    props.section.isSelected
  );
  // const [membersActiveOrders, setMembersActiveOrders] = useState<number[]>([]);

  const [lastyearSections, setLastyearSections] = useState<Number[]>([]);
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const [MembersActiveOrders, setMembersActiveOrders] = useState<
    IMemberShipOrders[]
  >([]);
  const [MembersActiveOrdersNumArray, setMembersActiveOrdersNumArray] =
    useState<number[]>([]);
  const [isMembersActiveOrdersLoaded, setIsMembersActiveOrders] =
    useState<boolean>(false);

  // console.log("props.section:", props.section);
  // console.log(
  //   "After:props.section.name:",
  //   props.section.SectionName,
  //   "-",
  //   props.section.isSelected,
  //   "-",
  //   checkboxIsSelected
  // );

  // useEffect(() => {
  //   console.log("isSelected: useEffect", checkboxIsSelected);
  // }, [checkboxIsSelected]);

  // useEffect(() => {
  //   if (
  //     MembersActiveOrders &&
  //     MembersActiveOrders[0]!.CurrentYearSections !== null
  //   ) {
  //     setMembersActiveOrdersNumArray(
  //       MembersActiveOrders[0]!.CurrentYearSections!.split(",").map(Number)
  //     );
  //   }
  // }, [MembersActiveOrders]);

  useEffect(() => {
    console.log("create order useEFFECT CALLED", currentMember);

    if (currentMember.Id !== null) {
      if (currentMember.BarId === "") {
        // console.log("currentMember EMPTY");
        navigate("/member", { replace: false });
      }
      // dispatch(resetOrderParameters());
      const getOrderListsForMemberID = async () => {
        try {
          const response = (props.isAdvanceOrder) ? await OrderServices.getFutureOrderByMemberId(
            currentMember.Id!
          ) : await OrderServices.getOrderByMemberId(
            currentMember.Id!
          );
          if (response.data.data != null) {
            if (response.data.hasErrors) {
              setShowAlertModal(true);
              setAlertTitle("Database Error");
              setAlertBody(response.data.errors[0].sqlMessage);
              return;
            }

            console.log("Success-getOrderByMemberId:", response.data.data);
            // setMembersActiveOrders(response.data.data);
            setMembersActiveOrders(response.data.data.memberShipOrderDetails);

            if (
              response.data.data.memberShipOrderDetails &&
              response.data.data.memberShipOrderDetails[0]!
                .CurrentYearSections !== null
            ) {
              setMembersActiveOrdersNumArray(
                response.data &&
                  response.data.data &&
                  response.data.data.memberShipOrderDetails &&
                  response.data.data.memberShipOrderDetails[0] &&
                  response.data.data.memberShipOrderDetails[0]
                    .CurrentYearSections &&
                  response.data.data.memberShipOrderDetails[0]!.CurrentYearSections!.split(
                    ","
                  ).map(Number)
              );

              
            }


            if(props.isAdvanceOrder &&  response.data.data.memberShipOrderDetails &&
              response.data.data.memberShipOrderDetails[0]!
                .CurrentYearSectionsNotPaid !== null){
              const _lastyearSections: number[] = response.data.data.memberShipOrderDetails[0].CurrentYearSectionsNotPaid.split(",").map(Number);

              //setLastyearSections(_lastyearSections);
              if (_lastyearSections.some((sectionId) => props.section.Id === sectionId)) {
                setCheckboxIsSelected(true);
              }
            }
            // setIsActiveOrdersDataLoaded(true);
          } else {
            // setIsActiveOrdersDataLoaded(true);
            // setIsActiveOrdersDataLoaded(false); // check this
          }
        } catch (error) {
          // setIsActiveOrdersDataLoaded(true);
          // setIsActiveOrdersDataLoaded(false); //check this
          // Handle errors from the API call
        }
      };

      getOrderListsForMemberID();
    }

    const _lastyearSections: number[] = currentMember.lastYearSections
      ? currentMember.lastYearSections.split(",").map(Number)
      : [];

    setLastyearSections(_lastyearSections);
    // BUG FIX: Do NOT pre-check last year sections. They should only display with
    // a "(Last Year)" label, not be checked by default. Pre-checking them causes
    // issues when the user unchecks them (negative totals) and doesn't make sense
    // since they're not active this year.
    // REMOVED: if (_lastyearSections.some(...)) { setCheckboxIsSelected(true); }
  }, []);

  // Keep checkbox UI in sync when the parent updates the member sections
  useEffect(() => {
    setCheckboxIsSelected(Boolean(props.section.isSelected));
  }, [props.section.isSelected]);

  useEffect(() => {
    setIsMembersActiveOrders(true);
    // console.log("MemberActiveORder1:", MembersActiveOrders);
  }, [MembersActiveOrders]);

  const handleChecked = (
    event: React.ChangeEvent<HTMLInputElement>,
    sectionItem: ISection
  ) => {
    setCheckboxIsSelected(!checkboxIsSelected);
    console.log("handleChecked section before update:", props.section);
    const updatedSection = {
      ...props.section,
      isSelected: !sectionItem.isSelected,
    };
    console.log("handleChecked section after update:", updatedSection);
    console.log("handleChecked-checkboxIsSelected:", checkboxIsSelected);
    props.onChangeFunction(event, updatedSection);
  };

  const toCamelCase = (str: string) => {
    if (!str) {
      return ""; // or handle it based on your use case
    }
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word: string, index: number) => {
        return index === 0 ? word.toUpperCase() : word.toLowerCase();
      })
      .replace(/\s+/g, "");
  };

  return (
    <>
      <div key={props.section.Id} className="checkboxgroup">
        <input
          id={String(props.section.Id)}
          className="checkbox"
          type="checkbox"
          checked={checkboxIsSelected}
          // checked={props.section.isSelected}
          // Only disable when we're in the "Add Sections" flow — allow removing in the Edit flow
          disabled={props.isAddSectionFlow === true && MembersActiveOrdersNumArray.some(
            (MemberCode) => MemberCode === props.section.Id
          )}
          onChange={(event) => {
            handleChecked(event, props.section);
          }}
        />
        <div>
          <span>
            {Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(props.section.Fee as number)}
          </span>

          <span> {props.section.SectionName}</span>
          <span>
            {lastyearSections.some(
              (sectionId) => props.section.Id === sectionId
            ) ? (
              <span style={{ color: "rgb(45, 33, 213)" }}>(Last Year)</span>
            ) : (
              <></>
            )}
          </span>
          {props.isAdvanceOrder === false && MembersActiveOrdersNumArray.some(
            (MemberCode) => MemberCode === props.section.Id
          ) ? (
            <span style={{ color: "green" }}>( Active )</span>
          ) : (
            <></>
          )}
        </div>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default MDEditSectionMultipleOptionItems;
